<div
    *ngIf="item?.layoutType === 'slider-with-subtext-v4'"
    class="common-layout-container-desktop"
    ngClass.xs="common-layout-container-mobile"
    [ngStyle]="sharedLayoutsService.getStyles(item?.layoutContent?.padding)"
>
    <div
        class="title-row"
        fxLayoutAlign="space-between end"
        *ngIf="
            item?.layoutContent?.title?.text ||
            item?.layoutContent?.button?.title?.text
        "
        [ngStyle.xs]="{ paddingRight: '16px' }"
    >
        <h1
            *ngIf="item?.layoutContent?.title?.text"
            class="layout-heading"
            [style]="{ color: item?.layoutContent?.title?.color }"
        >
            {{ item?.layoutContent?.title?.text }}
        </h1>
        <a
            *ngIf="item?.layoutContent?.button?.title?.text"
            class="view-all-button"
            [routerLink]="[item?.layoutContent?.button?.link | pageIdFromLink]"
            [queryParams]="
                item?.layoutContent?.button?.link | queryParamFromLink
            "
            [attr.aria-label]="
                item?.layoutContent?.button?.title?.text || 'banner-link'
            "
            [style]="{ color: item?.layoutContent?.button?.title?.color }"
        >
            {{ item?.layoutContent?.button?.title?.text }}
        </a>
    </div>

    <swiper
        [slidesPerView]="slidesPerView"
        [slidesPerGroup]="slidesPerView"
        [speed]="1300"
        [navigation]="true"
        [spaceBetween]="16"
        [pagination]="false"
        class="slider-with-subtext-v4-Swiper"
        fxHide.xs="true"
        *ngIf="item?.layoutContent?.slider?.length > 0"
    >
        <ng-template
            swiperSlide
            *ngFor="let feedItem of item?.layoutContent?.slider; let i = index"
        >
            <a
                *ngIf="feedItem?.banner?.image"
                [routerLink]="[feedItem?.banner?.link | pageIdFromLink]"
                [queryParams]="feedItem?.banner?.link | queryParamFromLink"
                [attr.aria-label]="feedItem?.title?.text || 'banner-link'"
                [style]="{
                    pointerEvents:
                        feedItem?.banner?.link && feedItem?.banner?.link !== ''
                            ? 'auto'
                            : 'none'
                }"
            >
                <picture
                    *ngIf="feedItem?.banner?.image"
                    [ngClass]="{
                        'image-slider-v2-shimmer': showShimmer
                    }"
                >
                    <img
                        *ngIf="feedItem?.banner?.image"
                        style="width: 100%; cursor: pointer"
                        [ngStyle.gt-xs]="{ marginBottom: '14.4px' }"
                        [src]="
                            hoveredIndex === i
                                ? feedItem?.banner?.altImage ||
                                  feedItem?.banner?.image
                                : feedItem?.banner?.image
                        "
                        [alt]="feedItem?.title?.text || 'banner'"
                        (mouseover)="onMouseOver(i)"
                        (mouseout)="onMouseOut()"
                    />
                </picture>
            </a>
            <div
                *ngIf="
                    feedItem?.subtextV2?.text ||
                    feedItem?.title?.text ||
                    feedItem?.price ||
                    feedItem?.subtitle?.text
                "
                class="swiper-card-content"
            >
                <p
                    *ngIf="feedItem?.subtextV2?.text"
                    class="subtext"
                    [style]="{ color: feedItem?.subtextV2?.color }"
                    >{{ feedItem?.subtextV2?.text }}</p
                >
                <h1
                    *ngIf="feedItem?.title?.text"
                    class="title truncate-text-single-line"
                    [style]="{ color: feedItem?.title?.color }"
                    >{{ feedItem.title?.text }}</h1
                >
                <span *ngIf="feedItem?.price" class="price">
                    <span
                        *ngIf="feedItem?.price?.title?.text"
                        class="title"
                        [style]="{ color: feedItem?.price?.title?.color }"
                        >{{ feedItem?.price?.title?.text }}</span
                    >
                    <p
                        *ngIf="feedItem?.price?.subtitle?.text"
                        class="title strikethrough-text"
                        [innerHTML]="
                            feedItem?.price?.subtitle?.text | lineBreak
                        "
                        [style]="{ color: feedItem?.price?.subtitle?.color }"
                        >{{ feedItem?.price?.subtitle?.text }}</p
                    >
                </span>
                <p
                    *ngIf="feedItem?.subtitle?.text"
                    class="subtitle"
                    [innerHTML]="feedItem?.subtitle?.text | lineBreak"
                    [style]="{ color: feedItem?.subtitle?.color }"
                    >{{ feedItem?.subtitle?.text }}</p
                >
            </div>
        </ng-template>
    </swiper>

    <app-custom-scrollbar
        scrollbarClass="hp-custom-scrollbar"
        scrollContainerSelector=".slider-cards-row"
    >
        <div
            fxLayout="row"
            *ngIf="item?.layoutContent?.slider?.length > 0"
            [ngStyle.xs]="{
                display: 'flex',
                overflowX: 'auto',
                overflowY: 'hidden',
                gap: '16px'
            }"
            fxHide.gt-xs="true"
            class="slider-cards-row"
            ngClass.xs="slider-cards-row-mobile"
        >
            <div
                fxLayout="column"
                *ngFor="let feedItem of item?.layoutContent?.slider"
                [ngStyle.xs]="{
                    flex: '0 0 52.646%',
                    margin: '0 0 16px 0'
                }"
            >
                <a
                    *ngIf="feedItem?.banner?.image"
                    [routerLink]="[feedItem?.banner?.link | pageIdFromLink]"
                    [queryParams]="feedItem?.banner?.link | queryParamFromLink"
                    [attr.aria-label]="feedItem?.title?.text || 'banner-link'"
                    style="margin-bottom: 8px"
                    [style]="{
                        pointerEvents:
                            feedItem?.banner?.link &&
                            feedItem?.banner?.link !== ''
                                ? 'auto'
                                : 'none'
                    }"
                >
                    <img
                        [src]="feedItem?.banner?.image"
                        alt="{{ feedItem.title?.text }}"
                        [style]="{
                            cursor:
                                feedItem?.banner?.link &&
                                feedItem?.banner?.link !== ''
                                    ? 'pointer'
                                    : 'auto'
                        }"
                        [ngClass]="{ 'image-banner-shimmer': showShimmer }"
                    />
                </a>
                <div
                    *ngIf="
                        feedItem?.subtextV2?.text ||
                        feedItem?.title?.text ||
                        feedItem?.price ||
                        feedItem?.subtitle?.text
                    "
                    fxLayout="column"
                    class="card-content"
                >
                    <p
                        *ngIf="feedItem?.subtextV2?.text"
                        class="subtext"
                        [style]="{ color: feedItem?.subtextV2?.color }"
                        >{{ feedItem?.subtextV2?.text }}</p
                    >
                    <h1
                        *ngIf="feedItem?.title?.text"
                        class="title truncate-text-single-line"
                        [style]="{ color: feedItem?.title?.color }"
                        >{{ feedItem.title?.text }}</h1
                    >
                    <span *ngIf="feedItem?.price" class="price">
                        <span
                            *ngIf="feedItem?.price?.title?.text"
                            class="price-title"
                            [style]="{ color: feedItem?.price?.title?.color }"
                            >{{ feedItem?.price?.title?.text }}</span
                        >
                        <span
                            *ngIf="feedItem?.price?.subtitle?.text"
                            class="price-title strikethrough-text"
                            [innerHTML]="
                                feedItem?.price?.subtitle?.text | lineBreak
                            "
                            [style]="{
                                color: feedItem?.price?.subtitle?.color
                            }"
                            >{{ feedItem?.price?.subtitle?.text }}</span
                        >
                    </span>
                    <p
                        *ngIf="feedItem?.subtitle?.text"
                        class="title"
                        [innerHTML]="feedItem?.subtitle?.text | lineBreak"
                        [style]="{ color: feedItem?.subtitle?.color }"
                        >{{ feedItem?.subtitle?.text }}</p
                    >
                </div>
            </div>
        </div>
    </app-custom-scrollbar>
</div>
